import { useQuery } from '@tanstack/react-query';
import { getUnreadNotificationCount } from '../api/fetchers/notificationFetcher';

const useGetUnreadNotificationCount = () => {
    return useQuery({
        queryKey: ['notifications-unread-count'],
        queryFn: () => getUnreadNotificationCount(),
        refetchInterval: 60000,
    });
};

export default useGetUnreadNotificationCount;
